import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const COOKIE_CONSENT_KEY = 'clevia-cookie-consent';

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay so it doesn't flash on page load
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-4 animate-in slide-in-from-bottom duration-500">
      <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-2xl shadow-2xl border border-gray-100 dark:border-gray-700/50 p-5 md:p-6">
        <div className="flex items-start gap-4">
          <div className="hidden sm:flex w-10 h-10 rounded-xl bg-[#16c47f]/10 items-center justify-center flex-shrink-0 mt-0.5">
            <Cookie className="w-5 h-5 text-[#16c47f]" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-3">
              <div>
                <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-1">
                  🍪 Ce site utilise des cookies
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
                  clevia utilise des cookies strictement nécessaires au fonctionnement du service
                  (authentification, préférences). Aucun cookie publicitaire ou de tracking n'est
                  utilisé.{' '}
                  <Link to="/p/cookies" className="text-[#16c47f] hover:underline font-medium">
                    En savoir plus
                  </Link>
                </p>
              </div>
              <button
                onClick={refuse}
                className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 flex-shrink-0"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            <div className="flex items-center gap-3 mt-4">
              <button
                onClick={accept}
                className="px-5 py-2 bg-[#16c47f] hover:bg-[#12b070] text-white text-sm font-semibold rounded-xl transition-colors"
              >
                Accepter
              </button>
              <button
                onClick={refuse}
                className="px-5 py-2 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 text-sm font-medium rounded-xl transition-colors"
              >
                Refuser
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
